export default function Delete() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 3.22222H11H1Z" fill="white" />
      <path
        d="M9.88889 3.22222V11C9.88889 11.5556 9.33333 12.1111 8.77778 12.1111H3.22222C2.66667 12.1111 2.11111 11.5556 2.11111 11V3.22222"
        fill="white"
      />
      <path
        d="M3.77778 3.22222V2.11111C3.77778 1.55556 4.33333 1 4.88889 1H7.11111C7.66667 1 8.22222 1.55556 8.22222 2.11111V3.22222"
        fill="white"
      />
      <path
        d="M1 3.22222H11M9.88889 3.22222V11C9.88889 11.5556 9.33333 12.1111 8.77778 12.1111H3.22222C2.66667 12.1111 2.11111 11.5556 2.11111 11V3.22222M3.77778 3.22222V2.11111C3.77778 1.55556 4.33333 1 4.88889 1H7.11111C7.66667 1 8.22222 1.55556 8.22222 2.11111V3.22222M4.88889 6V9.33333M7.11111 6V9.33333"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
